import { constructURL } from 'helpers/url';

// Loads calendar filters via an AJAX request and updates the filter lists in the UI.
// Assigns the method to the `window` object for global access.
//
// @return {void}
const loadCalendarFilters = () => {
  $('#filterMask').show();
  $.ajax({
    url: window.calendarSettings.filtersLink,
    method: 'GET',
    dataType: 'json',
    success(data) {
      const filtersList = $('#calendarFiltersSavedFilters');
      const filtersListOthers = $('#calendarFiltersSavedFiltersOthers');
      // Clear any existing items
      filtersList.empty();
      filtersListOthers.empty();
      // Loop through the data and create list items
      data.forEach((filter) => {
        if ((filter.admin && window.calendarSettings.isAdmin) || (!filter.admin && !window.calendarSettings.isAdmin)) {
          const listItem = $('<li>', { class: 'saved-calendar-filter list-group-item py-1 px-2' });
          const filterSpan = $('<span>', { class: 'loadFilter filter', text: filter.title, dataId: filter.id });
          const deleteLink = $('<a>', {
            href: '#',
            class: 'deleteFilter',
            style: 'float:right;',
            dataId: filter.id,
          }).append($('<i>', { class: 'bi bi-trash' }));
          if (filter.owner) {
            listItem.append(filterSpan).append(deleteLink);
            filtersList.append(listItem);
          } else {
            listItem.append(filterSpan);
            filtersListOthers.append(listItem);
          }
        }
      });
      $('#filterMask').hide();
      // Load quick buttons as defined in the calendar
      window.updateQuickButtons?.();
    },
    error(xhr, status, error) {
      console.error('Unable to load calendar filters:', status, error);
      $('#filterMask').hide();
    },
  });
};
// assign this to the window since we will call it directly sometimes
window.loadCalendarFilters = loadCalendarFilters;

// Applies filters to the calendar based on selected options.
//
// @param {boolean} admin - Indicates if the user is an admin.
// @return {void}
const applyCalendarFilters = (admin) => {
  let baseUrl = window.location.href;
  // Get existing URL parameters
  const url = new URL(baseUrl);
  const params = url.searchParams;
  // Therapist IDS (only admin)
  const therapistAutocomplete = document.querySelector('awc-autocomplete#therapists_ids');
  if (therapistAutocomplete) {
    const therapistIds = therapistAutocomplete.value;
    if (therapistIds.length > 0) {
      params.set('therapists', therapistIds.join(','));
    } else {
      params.delete('therapists');
    }
  }
  // Mode Type IDS
  const modeTypeIds = document.querySelector('awc-autocomplete#mode_type_ids').value;
  if (modeTypeIds.length > 0) {
    params.set('types', modeTypeIds.join(','));
  } else {
    params.delete('types');
  }
  // Patient IDS
  const patientIds = document.querySelector('awc-autocomplete#patient_ids').value;
  if (patientIds.length > 0) {
    params.set('patients', patientIds.join(','));
  } else {
    params.delete('patients');
  }
  url.search = params.toString();
  window.location = url.toString();
};

// Loads a calendar filter by its ID via an AJAX request and populates the filter form.
//
// @param {number} id - The ID of the calendar filter to load.
// @return {void}
const loadCalendarFilterById = (id) => {
  const url = window.calendarSettings?.loadFilterLink.replace('000', id);
  $.ajax({
    url,
    method: 'GET',
    dataType: 'json',
    success(data) {
      $('#calendar_filter_id').val(data.id);
      $('#calendar_filter_title').val(data.title);
      $('#calendar_filter_quick_button').prop('checked', data.quick_button);
      data.patient_ids.forEach((option) => {
        document.querySelector('awc-autocomplete#patient_ids').setValue(option[1], option[0]);
      });
      if (document.querySelector('awc-autocomplete#mode_type_ids')) {
        document.querySelector('awc-autocomplete#mode_type_ids').clear();
        data.mode_type_ids.forEach((option) => {
          document.querySelector('awc-autocomplete#mode_type_ids').setValue(option[1], option[0]);
        });
      }
      if (document.querySelector('awc-autocomplete#therapists_ids')) {
        document.querySelector('awc-autocomplete#therapists_ids').clear();
        data.therapist_ids.forEach((option) => {
          document.querySelector('awc-autocomplete#therapists_ids').setValue(option[1], option[0]);
        });
      }
    },
    error(xhr, status, error) {
      console.error('Request failed:', status, error);
    },
  });
};

// Saves the current filter configuration via an AJAX request.
//
// @return {void}
const saveCalendarFilter = () => {
  if (window?.calendarSettings?.saveFilterLink) {
    $('#calendarFilterSaveFilter').prop('disabled', true);
    $('#calendarFilterSaveError').addClass('hidden');
    // Make sure filter has name, public/private
    if ($('#calendar_filter_title').val() === '' || $('#calendar_filter_status').val() === '') {
      $('#calendarFilterSaveError').removeClass('hidden');
      $('#calendarFilterSaveFilter').prop('disabled', false);
      return false;
    }
    $.ajax({
      url: window?.calendarSettings?.saveFilterLink,
      method: 'POST',
      dataType: 'json',
      data: $('#caseload-new-form').serialize(),
      success(data) {
        loadCalendarFilters();
        loadCalendarFilterById(data.id);
        $('#calendarFilterSaveFilter').prop('disabled', false);
      },
      error(xhr, status, error) {
        console.error('AJAX request failed:', status, error);
      },
    });
  }
};

// Prepares the UI for creating a new filter by clearing the form inputs.
//
// @param {Event} event - The event object triggering this action.
// @return {void}
const newCalendarFilter = (event) => {
  if (event) { event.preventDefault(); }
  $('#calendarFilterSaveFilter').prop('disabled', false);
  $('#calendar_filter_id').val('');
  $('#calendar_filter_title').val('');
  $('#calendar_filter_quick_button').prop('checked', false);
  document.querySelector('awc-autocomplete#patient_ids').clear();
  document.querySelector('awc-autocomplete#mode_type_ids').clear();
  if (document.querySelector('awc-autocomplete#therapists_ids')) {
    document.querySelector('awc-autocomplete#therapists_ids').clear();
  }
};

// Loads a calendar filter back into the form based on the event's data.
//
// @param {Event} event - The event object containing the filter ID.
// @return {void}
const loadCalendarFilter = (event) => {
  event.preventDefault();
  newCalendarFilter(event);
  const id = $(event.target).attr('dataid');
  if (id) {
    loadCalendarFilterById(id);
  }
};

// Deletes a filter via an AJAX request, after confirming with the user.
//
// @param {Event} event - The event object triggering this action.
// @return {void}
const deleteCalendarFilter = (event) => {
  event.preventDefault();
  const dUrl = window.calendarSettings?.deleteFilterLink;
  const eId = $(event.target).parent().attr('dataid');
  if (!dUrl || !eId || !window.confirm("You're about to delete this filter.  Are you sure?")) {
    return;
  }
  $.ajax({
    url: dUrl.replace('000', eId),
    method: 'POST',
    dataType: 'json',
    success(data) {
      loadCalendarFilters();
      newCalendarFilter();
    },
    error(xhr,status, error) {
      console.error('Request failed:', status, error);
    },
  });
};

// Registers event listeners for various UI interactions related to filters and initializes the filters.
//
// @return {void}
window.registerFilters = () => {
  loadCalendarFilters();
  $(document).off('.calendar');
  $(document).on('click.calendar', '#calendarFiltersApplyFilter', applyCalendarFilters);
  $(document).on('click.calendar', '#calendarFilterSaveFilter', saveCalendarFilter);
  $(document).on('click.calendar', '#calendarFilterNewFilter', newCalendarFilter);
  $(document).on('click.calendar', 'span.loadFilter', loadCalendarFilter);
  $(document).on('click.calendar', 'a.deleteFilter', deleteCalendarFilter);
  $(document).on('click.calendar', '[data-bs-dismiss="modal"]', function () {
    $(this).closest('.modal').modal('hide');
  });
};
